export enum PreviewDevicesTasks {
    GetPreviewVideoStream = 'GetPreviewCameraStream',
    GetPreviewAudioStream = 'GetPreviewMicrophoneStream',
    ReinitSessionPreview = 'ReinitSessionPreview',
    StopVideoStream = 'StopVideoStream',
}

export const sessionPreviewQueueIgnoreMap = {
    [PreviewDevicesTasks.GetPreviewVideoStream]: new Set([
        PreviewDevicesTasks.GetPreviewVideoStream,
        PreviewDevicesTasks.StopVideoStream,
    ]),
    [PreviewDevicesTasks.GetPreviewAudioStream]: new Set([
        PreviewDevicesTasks.GetPreviewAudioStream,
        PreviewDevicesTasks.ReinitSessionPreview,
    ]),
    [PreviewDevicesTasks.ReinitSessionPreview]: new Set([
        PreviewDevicesTasks.GetPreviewVideoStream,
        PreviewDevicesTasks.GetPreviewAudioStream,
        PreviewDevicesTasks.ReinitSessionPreview,
        PreviewDevicesTasks.StopVideoStream,
    ]),
    [PreviewDevicesTasks.StopVideoStream]: new Set([
        PreviewDevicesTasks.GetPreviewVideoStream,
        PreviewDevicesTasks.StopVideoStream,
    ]),
} as const;
